var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Goal = exports.Whistle = exports.Card = exports.Substitution = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../../elements/Basic");

var _FontelloIcon = _interopRequireDefault(require("../../../Basic/FontelloIcon"));

var _i18n = _interopRequireDefault(require("../../../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Commentary/Events/Header.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Substitution = function Substitution(_ref) {
  var away = _ref.away,
      center = _ref.center;
  return _react.default.createElement(_Basic.Column, {
    flexing: true,
    alignRight: !center && away,
    center: center,
    alignLeft: !center && !away,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }, _react.default.createElement(_FontelloIcon.default, {
    name: "exchange",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 9
    }
  }));
};

exports.Substitution = Substitution;

var Card = function Card(_ref2) {
  var away = _ref2.away,
      color = _ref2.color,
      center = _ref2.center;
  return _react.default.createElement(_Basic.Column, {
    flexing: true,
    alignRight: !center && away,
    center: center,
    alignLeft: !center && !away,
    position: "relative",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 5
    }
  }, color === 'SECOND_YELLOW_CARD' ? _react.default.createElement(_react.default.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 13
    }
  }, _react.default.createElement(_FontelloIcon.default, {
    name: "card",
    color: "YELLOW_CARD",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 17
    }
  }), _react.default.createElement(_FontelloIcon.default, {
    name: "card-yellow-red",
    color: "RED_CARD",
    position: "absolute",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 17
    }
  })) : _react.default.createElement(_FontelloIcon.default, {
    name: "card",
    color: color,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 13
    }
  }));
};

exports.Card = Card;

var Whistle = function Whistle() {
  return _react.default.createElement(_Basic.Row, {
    center: true,
    mb: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 5
    }
  }, _react.default.createElement(_FontelloIcon.default, {
    name: "WHISTLE",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 9
    }
  }));
};

exports.Whistle = Whistle;

var Goal = function Goal(_ref3) {
  var away = _ref3.away,
      scoreHome = _ref3.scoreHome,
      scoreAway = _ref3.scoreAway,
      center = _ref3.center;
  return _react.default.createElement(_Basic.Column, {
    flexing: true,
    alignRight: !center && away,
    center: center,
    alignLeft: !center && !away,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Row, {
    center: true,
    reverseRow: away,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 9
    }
  }, _react.default.createElement(_FontelloIcon.default, {
    name: "GOAL",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 13
    }
  }), _react.default.createElement(_Basic.Text, {
    bold: true,
    fontSize: 1,
    mx: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 13
    }
  }, scoreHome + " : " + scoreAway)));
};

exports.Goal = Goal;

var Header = function (_React$Component) {
  (0, _inherits2.default)(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header() {
    (0, _classCallCheck2.default)(this, Header);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Header, [{
    key: "renderType",
    value: function renderType() {
      var _this$props = this.props,
          away = _this$props.away,
          substitution = _this$props.substitution,
          scoreHome = _this$props.scoreHome,
          scoreAway = _this$props.scoreAway,
          card = _this$props.card,
          center = _this$props.center;

      if (substitution) {
        return _react.default.createElement(Substitution, {
          away: away,
          center: center,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 70,
            columnNumber: 20
          }
        });
      } else if (typeof scoreHome === 'number' && typeof scoreAway === 'number') {
        return _react.default.createElement(Goal, {
          away: away,
          scoreHome: scoreHome,
          scoreAway: scoreAway,
          center: center,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 72,
            columnNumber: 20
          }
        });
      } else if (card) {
        return _react.default.createElement(Card, {
          away: away,
          color: card,
          center: center,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 74,
            columnNumber: 20
          }
        });
      }

      return _react.default.createElement(_Basic.Column, {
        flexing: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77,
          columnNumber: 16
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          minute = _this$props2.minute,
          isPenaltyShootout = _this$props2.isPenaltyShootout,
          away = _this$props2.away,
          center = _this$props2.center;
      var row = this.renderType();
      return _react.default.createElement(_Basic.Row, {
        reverseRow: !center && away,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85,
          columnNumber: 13
        }
      }, row, _react.default.createElement(_Basic.View, {
        center: true,
        isFlex: true,
        m: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Text, {
        fontSize: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 88,
          columnNumber: 21
        }
      }, isPenaltyShootout ? (0, _i18n.default)('penalty_shootout') : minute)), _react.default.createElement(_Basic.Column, {
        flexing: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 92,
          columnNumber: 17
        }
      }));
    }
  }]);
  return Header;
}(_react.default.Component);

exports.default = Header;
Header.propTypes = {
  minute: _propTypes.default.string.isRequired,
  isPenaltyShootout: _propTypes.default.bool,
  away: _propTypes.default.bool,
  substitution: _propTypes.default.bool,
  scoreHome: _propTypes.default.number,
  scoreAway: _propTypes.default.number,
  card: _propTypes.default.string,
  center: _propTypes.default.bool
};
Header.defaultProps = {
  away: false,
  center: false
};